// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"371994ab","172":"371994ab","493":"371994ab","553":"371994ab","940":"371994ab"}[chunkId] + ".chunk.css";
};